<script>
  import { ROUTES } from '@utils/routes.js';
  import ButtonNeu from "lib/components/Button.svelte";

  export let idproject;
  export let exportPreprocessingSteps;
  export let importPreprocessingSteps;
  export let downloadAppOverviewAll;
</script>

<!-- @Adrian please add function for testing all rules -->
<ButtonNeu
  text="Test All Rules"
  variant="secondary"
  disabled
  notAllowed
  on:click={downloadAppOverviewAll}
/>
<ButtonNeu
  text="Export Rules"
  on:click={exportPreprocessingSteps}
  iconLeft={true}
  icon={"download"}
  variant="secondary"
/>
<ButtonNeu
  text="Import Rules"
  on:click={importPreprocessingSteps}
  iconLeft={true}
  icon={"upload"}
  variant="secondary"
/>
<ButtonNeu
  text="Anonymization Assistant"
  on:click={() => {
    window.open(
      `${ROUTES.dam.anonymizationAssistant}?idproject=${idproject}&step=2`,
      "_blank"
    );
  }}
  variant="secondary"
/>
